import React from 'react'

import { useForm } from './_load/FormLoader'
import FormResumePageHeader from '../../forms/_shared/FormResumePageHeader'

const PageHeader = () => {
  const form = useForm()

  return <FormResumePageHeader form={form} />
}

export default PageHeader
